export enum CatalogItemStatus {
  Active = "ACTIVE",
  Inactive = "INACTIVE"
}

export interface CatalogItem {
  id: string;
  code: string;
  label: string;
  description?: string;
  order: number;
  status: CatalogItemStatus;
  metadata?: Record<string, any>;
}

export interface CatalogSchema {
  items: CatalogItem[];
}
